module.exports = __webpack_public_path__ + "img/ja-logo.3dc60cd4.svg";